<template>
  <Menu.Submenu
    :label="EDITOR_MODES[mode].label"
    :icon="EDITOR_MODES[mode].icon"
    data-emphasis-identifier="editor-mode-dropdown"
  >
    <Menu.RadioGroup :model-value="mode">
      <Menu.RadioItem
        value="fancy"
        label="Fancy mode"
        icon="sparkles"
        @select="emit('switch', 'fancy')"
      />
      <Menu.RadioItem
        value="plaintext"
        label="Markdown mode"
        icon="code-bracket"
        @select="emit('switch', 'plaintext')"
      />

      <Tooltip.PremiumOnly
        v-slot="{ planRequired, redirect }"
        feature="naked_mode"
      >
        <Menu.RadioItem
          value="naked"
          label="Naked mode"
          icon="file-code"
          :premium="!!planRequired"
          @select="!planRequired ? emit('switch', 'naked') : redirect()"
        />
      </Tooltip.PremiumOnly>
    </Menu.RadioGroup>
  </Menu.Submenu>
</template>

<script setup lang="ts">
import Menu from "@/design_system/Menu";
import Tooltip from "@/design_system/Tooltip";
import { EDITOR_MODES } from "@/lib/editor/editor-modes";
import type { EditorMode } from "@/types/email";

defineProps<{
  mode: EditorMode;
}>();

const emit = defineEmits<{
  switch: [mode: EditorMode];
}>();
</script>
